module.exports = __webpack_public_path__ + "img/add-member-icon.f5280a74.svg";